import { Html } from "@react-three/drei";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Color, RGBAFormat } from "three";

export default function Intro() {
  return (
    <>
      <div>
        <h3 className="bold white-text">Hey! I'm</h3>
        <div className="default-row-spacer" />

        <div className="typewriter" style={{ display: "inline-block" }}>
          <h1 className="bold">William Zhang...</h1>
        </div>
        <br />
        <div className="large-row-spacer" />
        <div className="d-flex justify-content-center">
          <img src="Will.jpg" alt="" className="medium-image" />
        </div>
        <div className="large-row-spacer"></div>

        <div>
          <p
            className="semi-bold initial-fade-in fade-in-and-out"
            style={{ color: "#C5C5C5" }}
          >
            Scroll to learn more about me!
          </p>
        </div>
      </div>
    </>
  );
}
